import React, { useState, useEffect } from 'react';
import { BloomWordmark } from './LotusLogo';

// Krátké bliknutí loga při otevření aplikace. Ukáže se jen jednou za návštěvu
// (sessionStorage), aby to při každém překliknutí neotravovalo.
const HOLD_MS = 900;   // jak dlouho logo zůstane
const FADE_MS = 400;   // jak dlouho trvá zmizení

export default function LotusIntro() {
  // Lazy initializer proběhne jednou za připojení; přežije i dvojí spuštění ve StrictMode
  const [phase, setPhase] = useState(() =>
    sessionStorage.getItem('bloom_intro_shown') ? 'done' : 'visible'
  );

  useEffect(() => {
    if (phase === 'done') return;
    sessionStorage.setItem('bloom_intro_shown', '1');
    const t1 = setTimeout(() => setPhase('fadeout'), HOLD_MS);
    const t2 = setTimeout(() => setPhase('done'), HOLD_MS + FADE_MS);
    return () => { clearTimeout(t1); clearTimeout(t2); };
    // Záměrně jen při připojení – intro se má spustit jednou, ne při každé změně fáze.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (phase === 'done') return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'var(--color-bloom-bg, #FCFBFF)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: phase === 'fadeout' ? `introFadeOut ${FADE_MS}ms ease-out forwards` : 'none',
        pointerEvents: phase === 'fadeout' ? 'none' : 'all',
      }}
      data-testid="lotus-intro"
    >
      <div style={{ animation: 'logoBlink 0.9s ease-out both' }}>
        <BloomWordmark size={112} />
      </div>
    </div>
  );
}
